import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AlertBox = styled(Box)(({ theme, bgcolor }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'var(--alert-equip-size, 20px)',
    height: 'var(--alert-equip-size, 20px)',
    borderRadius: '50%',
    backgroundColor: bgcolor || theme.palette.grey[300],
    color: theme.palette.common.white,
    fontSize: 'var(--alert-equip-font-size, 12px)',
    marginRight: theme.spacing(0.5),
}));

export const AuthTypography = styled(Typography)({
    display: 'flex',
    flexWrap: 'wrap',
    wordBreak: 'break-word',
    width: 200,
    fontSize: 12,
});

export const RecentChip = styled(Chip)({
    '& .MuiChip-label': {
        fontSize: '8px',
    },
    height: '16px',
    fontSize: '8px',
});

export const SectionLabel = styled(Typography)({
    fontSize: 12,
    fontWeight: 500,
    minWidth: 40,
});
